import React from 'react';

import TabbedModal from 'app/components/general/TabbedModal';
import {gt} from 'app/utils/i18n';

interface Props {
  show: boolean;
  onToggle: () => unknown;
  onClosed?: () => unknown;
  name?: string;
  children: React.ReactNode;
}

export function BaseAssignTaskModalChrome({
  show,
  onToggle,
  onClosed,
  name,
  children,
}: Props) {
  return (
    <TabbedModal
      show={show}
      onCancel={onToggle}
      onClosed={onClosed}
      modalBodyClass="p-0"
      tabs={[
        {
          eventKey: 'main-tab',
          name: name ?? gt('Assign Task'),
          icon: 'fa fa-user',
          content: children,
        },
      ]}
    />
  );
}
